module.exports = __webpack_public_path__ + "static/media/map-srb.e1435de7.jpg";